import * as l from './UnitTokenTranslation.loc.js';
export const UnitTokenTranslation = (lang, token) => l[token](lang);
//# sourceMappingURL=UnitTokenTranslation.js.map